export default "__VITE_ASSET__DvYenojB__"